import styled from 'styled-components'
import theme from 'theme_'
import { Font14, Regular } from 'components/Typography'

export const StyledTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`

export const StyledTableDesktop = styled.div<{ $showPagination: boolean }>`
  display: none;
  flex-direction: column;
  align-items: center;
  background: ${theme.colors.white};
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
  border-radius: ${(p) => (p.$showPagination ? '8px 8px 0 0' : '8px')};
  @media ${theme.devices.tablet} {
    display: flex;
  }
`

export const StyledTableMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const StyledTableHeader = styled.div`
  width: 100%;
  font-weight: 400;
  ${Font14};
  line-height: 22px;
  color: ${theme.colors.duneWarmGrey};
  display: none;
  @media ${theme.devices.tablet} {
    display: block;
  }
`

export const StyledHeaderTr = styled.div`
  height: 48px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.05);
`

export const StyledHeaderTh = styled.div<{
  percentWidth?: string
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  padding: 13px 24px;
  ${(p) =>
    p.percentWidth &&
    `
    width: ${p.percentWidth} !important
  `}
`

export const StyledTableBody = styled.div`
  width: 100%;
  font-weight: 400;
  color: ${theme.colors.duneWarmGrey};
`

export const StyledTableBodyMobile = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

export const StyledBodyTr = styled.div<{
  $selectedRowIndex: number | undefined
  $rowIndex: number | undefined
  $isStriped: boolean | undefined
  $showPagination: boolean | undefined
  $shouldRowBeLink: boolean | undefined
  onClick?: any
}>`
  height: 64px;
  box-shadow: ${(p) => !p?.$isStriped && '0 1px 0 rgba(0, 0, 0, 0.05)'};
  transition: outline 0.3s;
  will-change: box-shadow;
  text-decoration: none;
  color: unset;
  ${(p) =>
    p?.$selectedRowIndex === p?.$rowIndex &&
    `background: ${theme.colors.accent10};
    box-shadow: inset 0 0 0 1px ${theme.colors.horizonOrange}`};

  ${(p) =>
    p?.$showPagination === false &&
    `:last-child {
      border-radius: 0 0 8px 8px;
  }`};

  &:nth-child(even) {
    background: ${(p) => p?.$isStriped && theme.colors.lighterGrey};
  }

  &:hover {
    ${(p) =>
      (p.onClick || p.$shouldRowBeLink) &&
      `cursor: pointer;
       box-shadow: inset 0 0 0 1px ${theme.colors.horizonOrange}
       `}
  }
`

export const StyledBodyTrMobile = styled.div<{
  $selectedRowIndex: number | undefined
  $rowIndex: number | undefined
}>`
  width: 100%;
  ${(p) =>
    p?.$selectedRowIndex === p?.$rowIndex &&
    `background: ${theme.colors.accent10};
    border-radius: 8px;
    box-shadow: 0 0 0 1px ${theme.colors.horizonOrange};
    `};
`

export const StyledBodyTd = styled.div<{
  percentWidth?: string
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  height: 100%;
  padding: 24px;
  ${Font14};
  ${(p) =>
    p.percentWidth &&
    `
    width: ${p.percentWidth} !important
  `}
`

export const StyledNoRows = styled(Regular)`
  display: flex;
  margin-top: 16px;
  margin-bottom: 16px;
  flex-direction: row;
  height: 64px;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${theme.colors.disabledGrey};
`

export const TableHiddenAbsoluteBlock = styled.div`
  position: absolute;
  width: 100%;
`

export const TableWithPaginationWrapper = styled.div`
  position: relative;

  @media ${theme.devices.tablet} {
    overflow: auto;
    border-radius: 8px;
  }
  @media ${theme.devices.mediumDesktop} {
    overflow: initial;
  }
`
